import { createSelector } from 'reselect';
import { prop, propOr, pipe, values, length } from 'ramda';

export const selectUserDomain = prop('user');

export const selectUserData = createSelector(
  selectUserDomain,
  prop('data')
);

export const selectUserDataIsBeingListened = createSelector(
  selectUserDomain,
  prop('isBeingListened')
);

export const selectUserDataIsUpdating = createSelector(
  selectUserDomain,
  prop('isUpdating')
);

export const selectUserDataIsChangingPassword = createSelector(
  selectUserDomain,
  prop('isChangingPassword')
);

export const selectUserBookings = createSelector(
  selectUserData,
  propOr({}, 'bookings')
);

export const selectUserBookingsNumber = createSelector(
  selectUserBookings,
  pipe(
    values,
    length
  )
);
